<template>
  <div id="app" class="app-shell">
    <el-container class="app-shell__container" direction="vertical">
      <el-header class="app-shell__header" height="56px">
        <NavMenu />
      </el-header>
      <el-main class="app-shell__main">
        <MainView />
      </el-main>
      <el-footer class="app-shell__footer" height="auto">
        <AppFooter />
      </el-footer>
    </el-container>
  </div>
</template>

<script setup lang="ts">
import NavMenu from "@/components/NavMenu.vue";
import AppFooter from "@/components/Footer.vue";
import MainView from "@/components/Main.vue";
</script>

<style>
html,
body,
#app {
  margin: 0;
  min-height: 100%;
  overflow-x: hidden;
}

.app-shell,
.app-shell__container {
  min-height: 100vh;
  width: 100%;
}

.app-shell__header {
  padding: 0;
  border-bottom: 1px solid #ebeef5;
}

.app-shell__main {
  flex: 1 0 auto;
  padding: 16px;
  box-sizing: border-box;
  overflow: visible;
}

.app-shell__footer {
  padding: 0;
  height: auto !important;
  flex-shrink: 0;
}

@media (max-width: 768px) {
  .app-shell__main {
    padding: 12px 8px;
  }
}
</style>
